export default __webpack_public_path__ + "static/media/manual-warning.f87a378e.svg";